export default `.vuiFlexContainer {
  display: flex;
  align-items: stretch;
}

.vuiFlexContainer--fullWidth {
  width: 100%;
}

.vuiFlexContainer--wrap {
  flex-wrap: wrap;
}

.vuiFlexContainer--alignItemsBaseline {
  align-items: baseline;
}

.vuiFlexContainer--alignItemsCenter {
  align-items: center;
}

.vuiFlexContainer--alignItemsEnd {
  align-items: end;
}

.vuiFlexContainer--alignItemsStart {
  align-items: start;
}

.vuiFlexContainer--alignItemsStretch {
  align-items: stretch;
}

.vuiFlexContainer--directionColumn {
  flex-direction: column;
}

.vuiFlexContainer--directionColumnReverse {
  flex-direction: column-reverse;
}

.vuiFlexContainer--directionRow {
  flex-direction: row;
}

.vuiFlexContainer--directionRowReverse {
  flex-direction: row-reverse;
}

.vuiFlexContainer--justifyContentCenter {
  justify-content: center;
}

.vuiFlexContainer--justifyContentEnd {
  justify-content: end;
}

.vuiFlexContainer--justifyContentStart {
  justify-content: start;
}

.vuiFlexContainer--justifyContentSpaceAround {
  justify-content: space-around;
}

.vuiFlexContainer--justifyContentSpaceBetween {
  justify-content: space-between;
}

.vuiFlexContainer--justifyContentSpaceEvenly {
  justify-content: space-evenly;
}

.vuiFlexContainer--spacingNone {
  margin: 0;
}
.vuiFlexContainer--spacingNone > .vuiFlexItem {
  margin: 0;
}

.vuiFlexContainer--spacingXxs {
  margin: -2px;
}
.vuiFlexContainer--spacingXxs > .vuiFlexItem {
  margin: 2px;
}

.vuiFlexContainer--spacingXs {
  margin: -4px;
}
.vuiFlexContainer--spacingXs > .vuiFlexItem {
  margin: 4px;
}

.vuiFlexContainer--spacingS {
  margin: -6px;
}
.vuiFlexContainer--spacingS > .vuiFlexItem {
  margin: 6px;
}

.vuiFlexContainer--spacingM {
  margin: -8px;
}
.vuiFlexContainer--spacingM > .vuiFlexItem {
  margin: 8px;
}

.vuiFlexContainer--spacingL {
  margin: -12px;
}
.vuiFlexContainer--spacingL > .vuiFlexItem {
  margin: 12px;
}

.vuiFlexContainer--spacingXl {
  margin: -16px;
}
.vuiFlexContainer--spacingXl > .vuiFlexItem {
  margin: 16px;
}

.vuiFlexContainer--spacingXxl {
  margin: -20px;
}
.vuiFlexContainer--spacingXxl > .vuiFlexItem {
  margin: 20px;
}

.vuiFlexItem {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.vuiFlexItem--truncate {
  min-width: 40px;
}

.vuiFlexItem--alignItemsBaseline {
  align-items: baseline;
}

.vuiFlexItem--alignItemsCenter {
  align-items: center;
}

.vuiFlexItem--alignItemsEnd {
  align-items: end;
}

.vuiFlexItem--alignItemsStart {
  align-items: start;
}

.vuiFlexItem--alignItemsStretch {
  align-items: stretch;
}

.vuiFlexItem--flexGrow0 {
  flex-grow: 0;
}

.vuiFlexItem--flexGrow1 {
  flex-grow: 1;
}

.vuiFlexItem--flexGrow2 {
  flex-grow: 2;
}

.vuiFlexItem--flexGrow3 {
  flex-grow: 3;
}

.vuiFlexItem--flexGrow4 {
  flex-grow: 4;
}

.vuiFlexItem--flexGrow5 {
  flex-grow: 5;
}

.vuiFlexItem--flexGrow6 {
  flex-grow: 6;
}

.vuiFlexItem--flexGrow7 {
  flex-grow: 7;
}

.vuiFlexItem--flexGrow8 {
  flex-grow: 8;
}

.vuiFlexItem--flexGrow9 {
  flex-grow: 9;
}

.vuiFlexItem--flexGrow10 {
  flex-grow: 10;
}

.vuiFlexItem--flexGrowNone {
  flex-basis: auto;
  flex-grow: 0;
}

.vuiFlexItem--flexShrink0 {
  flex-shrink: 0;
}

.vuiFlexItem--flexShrink1 {
  flex-shrink: 1;
}

.vuiFlexItem--flexShrink2 {
  flex-shrink: 2;
}

.vuiFlexItem--flexShrink3 {
  flex-shrink: 3;
}

.vuiFlexItem--flexShrink4 {
  flex-shrink: 4;
}

.vuiFlexItem--flexShrink5 {
  flex-shrink: 5;
}

.vuiFlexItem--flexShrink6 {
  flex-shrink: 6;
}

.vuiFlexItem--flexShrink7 {
  flex-shrink: 7;
}

.vuiFlexItem--flexShrink8 {
  flex-shrink: 8;
}

.vuiFlexItem--flexShrink9 {
  flex-shrink: 9;
}

.vuiFlexItem--flexShrink10 {
  flex-shrink: 10;
}

.vuiFlexItem--flexShrinkNone {
  flex-basis: auto;
  flex-shrink: 0;
}

.vuiFlexItem--auto {
  flex-basis: auto;
}

.vuiFlexItem--content {
  flex-basis: content;
}

.vuiFlexItem--fill {
  flex-basis: fill;
}

.vuiFlexItem--maxContent {
  flex-basis: max-content;
}

.vuiFlexItem--minContent {
  flex-basis: min-content;
}

.vuiFlexItem--none {
  flex-basis: 0;
}

.vuiScreenBlock {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
}

.vuiScreenBlock__mask {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
}

.vuiSpacer {
  flex-shrink: 0;
}

.vuiSpacer--xxxs {
  height: 2px;
}

.vuiSpacer--xxs {
  height: 4px;
}

.vuiSpacer--xs {
  height: 8px;
}

.vuiSpacer--s {
  height: 12px;
}

.vuiSpacer--m {
  height: 16px;
}

.vuiSpacer--l {
  height: 24px;
}

.vuiSpacer--xl {
  height: 32px;
}

.vuiSpacer--xxl {
  height: 40px;
}

.vuiSpinner--accent svg path,
.vuiSpinner--accent svg rect {
  fill: #551edf;
}

.vuiSpinner--primary svg path,
.vuiSpinner--primary svg rect {
  fill: rgb(38, 76, 214);
}

.vuiSpinner--success svg path,
.vuiSpinner--success svg rect {
  fill: #04821f;
}

.vuiSpinner--danger svg path,
.vuiSpinner--danger svg rect {
  fill: #c41535;
}

.vuiSpinner--warning svg path,
.vuiSpinner--warning svg rect {
  fill: #965a15;
}

.vuiSpinner--empty svg path,
.vuiSpinner--empty svg rect {
  fill: #ffffff;
}

.vuiSpinner--dark svg path,
.vuiSpinner--dark svg rect {
  fill: #2c313a;
}

.vuiSpinner--xs {
  width: 14px;
  height: 14px;
}

.vuiSpinner--s {
  width: 15.9px;
  height: 15.9px;
}

.vuiSpinner--m {
  width: 20.08px;
  height: 20.08px;
}

.vuiSpinner--l {
  width: 48px;
  height: 48px;
}

.vuiSpinner--xl {
  width: 64px;
  height: 64px;
}

.vuiSpinner--xxl {
  width: 80px;
  height: 80px;
}

.vuiSpinner--xxxl {
  width: 100px;
  height: 100px;
}

.vuiToggle {
  position: relative;
  display: inline-block;
  width: 36px;
  height: 20px;
}

.vuiToggle__input {
  opacity: 0;
  width: 0;
  height: 0;
}
.vuiToggle__input:checked + .vuiToggle__button {
  background-color: rgb(38, 76, 214);
}
.vuiToggle__input:focus-visible + .vuiToggle__button {
  outline: 2px solid rgba(38, 76, 214, 0.75);
  outline-offset: 2px;
}
.vuiToggle__input:checked + .vuiToggle__button:before {
  transform: translateX(16px);
}

.vuiToggle__button {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #cbcdde;
  transition: 0.2s;
  border-radius: 16px;
  box-shadow: inset rgba(0, 0, 0, 0.1) 0px 2px 2px;
}
.vuiToggle__button:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 2px;
  background-color: #ffffff;
  transition: 0.2s;
  border-radius: 50%;
}

.vuiTitle {
  color: #2c313a;
  margin-bottom: 0;
}

.vuiTitle--xxs {
  font-size: 12px;
  line-height: 12px;
  font-weight: 400;
  color: #2c313a;
}

.vuiTitle--xs {
  font-size: 14px;
  line-height: 14px;
  font-weight: 600;
  color: #2c313a;
}

.vuiTitle--s {
  font-size: 18px;
  line-height: 18px;
  font-weight: 600;
  color: #69707d;
}

.vuiTitle--m {
  font-size: 24px;
  line-height: 24px;
  font-weight: 600;
  color: #2c313a;
}

.vuiTitle--l {
  font-size: 30px;
  line-height: 30px;
  font-weight: 400;
  color: #2c313a;
}

.vuiTitle--xl {
  font-size: 40px;
  line-height: 40px;
  font-weight: 400;
  color: #2c313a;
}

.vuiTitle--xxl {
  font-size: 40px;
  line-height: 40px;
  font-weight: 600;
  color: #2c313a;
}

.vuiTitle--left {
  text-align: left;
}

.vuiTitle--center {
  text-align: center;
}

.vuiTitle--right {
  text-align: right;
}

.vuiText {
  overflow-wrap: break-word;
  word-break: break-word;
}
.vuiText ul {
  list-style: disc;
}
.vuiText ol {
  list-style: auto;
}
.vuiText ul,
.vuiText ol {
  margin-left: 16px;
  margin-bottom: 8px;
}
.vuiText ul:last-child,
.vuiText ol:last-child {
  margin-bottom: 0;
}
.vuiText a {
  color: rgb(38, 76, 214);
}

.vuiText--truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vuiText--truncate * {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vuiText--xs {
  color: #2c313a;
  font-size: 12px;
  line-height: 1.4;
}
.vuiText--xs p {
  font-size: 12px;
  line-height: 1.4;
  margin-bottom: 8px;
}
.vuiText--xs p:last-child {
  margin-bottom: 0;
}

.vuiText--s {
  color: #2c313a;
  font-size: 14px;
  line-height: 1.4;
}
.vuiText--s p {
  font-size: 14px;
  line-height: 1.4;
  margin-bottom: 8px;
}
.vuiText--s p:last-child {
  margin-bottom: 0;
}

.vuiText--m {
  color: #2c313a;
  font-size: 16px;
  line-height: 1.4;
}
.vuiText--m p {
  font-size: 16px;
  line-height: 1.4;
  margin-bottom: 8px;
}
.vuiText--m p:last-child {
  margin-bottom: 0;
}

.vuiText--l {
  color: #2c313a;
  font-size: 18px;
  line-height: 1.4;
}
.vuiText--l p {
  font-size: 18px;
  line-height: 1.4;
  margin-bottom: 8px;
}
.vuiText--l p:last-child {
  margin-bottom: 0;
}

.vuiText--left {
  text-align: left;
}

.vuiText--center {
  text-align: center;
}

.vuiText--right {
  text-align: right;
}

.vuiTextColor--accent {
  color: #551edf !important;
}

.vuiTextColor--primary {
  color: rgb(38, 76, 214) !important;
}

.vuiTextColor--success {
  color: #04821f !important;
}

.vuiTextColor--warning {
  color: #965a15 !important;
}

.vuiTextColor--danger {
  color: #c41535 !important;
}

.vuiTextColor--subdued {
  color: #69707d !important;
}

.vuiTextColor--neutral {
  color: #2c313a !important;
}

body,
textarea {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
}

*,
*:before,
*:after {
  box-sizing: border-box;
}

html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: none;
  vertical-align: baseline;
}

h1,
h2,
h3,
h4,
h5,
h6,
p {
  font-family: inherit;
  font-weight: inherit;
  font-size: inherit;
}

/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

a[href],
button,
[role=button] {
  cursor: pointer;
}

button {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  color: inherit;
  border-radius: 0;
  font-size: inherit;
}

input {
  margin: 0;
  padding: 0;
}

input:disabled {
  opacity: 1; /* required on iOS */
}

ol,
ul {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

hr {
  margin: 0;
}

fieldset {
  min-inline-size: auto;
}

.vrsAnswerContainer {
  border-top: 1px solid #e3e4f3;
  padding: 16px 24px;
}

.vrsSearchForm {
  position: relative;
  display: flex;
  align-items: center;
}

.vrsSearchInput {
  flex-grow: 1;
  padding: 24px;
  background-color: #ffffff;
  border: none;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 0px 0px 0px, rgba(60, 64, 67, 0.15) 0px 0px 0px 0px;
  outline-width: 1px;
  outline-style: solid;
  outline-color: transparent;
  outline-offset: -1px;
  font-size: 18px;
  color: #2c313a;
}

.vrsCloseButtonWrapper {
  display: none;
  padding-left: 16px;
}

.vrsSubmitButtonWrapper {
  padding-right: 16px;
}

.vrsSubmitButton {
  line-height: 0;
  color: #69707d;
  transition: all 0.2s;
}
.vrsSubmitButton:hover {
  color: rgb(38, 76, 214);
}

@media only screen and (max-width: 740px) {
  .vrsCloseButtonWrapper {
    display: initial;
  }
}
.vrsSearchResult {
  background-color: #ffffff;
  display: block;
  padding: 12px 24px 12px 24px;
  text-decoration: none;
  border-bottom: 1px solid #e3e4f3;
}
.vrsSearchResult:hover {
  background-color: #f3f7fb;
}
.vrsSearchResult:last-of-type {
  border-bottom: none;
}

.vrsSearchResult-isLink {
  padding-left: 16px;
  border-left: 12px solid #ffffff;
}
.vrsSearchResult-isLink:hover, .vrsSearchResult-isLink.isSelected {
  border-left: 12px solid rgb(38, 76, 214);
}
.vrsSearchResult-isLink:hover .vrsSearchResultTitle, .vrsSearchResult-isLink.isSelected .vrsSearchResultTitle {
  text-decoration: underline;
}
.vrsSearchResult-isLink .vrsSearchResultTitle {
  color: rgb(38, 76, 214);
}

.vrsSearchResultTitle {
  color: #2c313a;
  font-size: 14px;
  font-weight: 700;
  line-height: 22px;
  margin-bottom: 4px;
}

.vrsSearchResultSnippet {
  color: #2c313a;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 0;
}

:host {
  all: initial;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
}

.vrsSearchModalContainer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  animation: modalIn 0.2s cubic-bezier(0, 1, 1, 1);
  pointer-events: none;
}
.vrsSearchModalContainer .vrsSearchModal {
  margin-top: 6vh;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 720px;
  max-height: 88vh;
  z-index: 12;
  pointer-events: all;
  background-color: #ffffff;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  border-radius: 8px;
  overflow: hidden;
}
.vrsSearchModalContainer .vrsSearchModalResults {
  border-top: 1px solid #e3e4f3;
  overflow-y: auto;
}

@media only screen and (max-width: 740px) {
  .vrsSearchModalContainer {
    overflow-y: auto;
  }
  .vrsSearchModalContainer .vrsSearchModal {
    margin-top: 0 !important;
    max-width: 100vw !important;
    max-height: none !important;
    border-radius: 0 !important;
    overflow: initial !important;
  }
  .vrsSearchModalContainer .vrsSearchModalResults {
    overflow-y: none !important;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
